// import ProductCard from "../ProductCard";

// const ProductsRow = ({ title, products, showBuyNow }) => {
//   if (!products?.length) return null;

//   return (
//     <section className="mb-14 px-6">
//       <h3 className="text-lg font-bold text-center mb-5 italic">
//         {title}
//       </h3>

//       <div
//         className="
//           flex gap-6
//           overflow-x-auto
//           pb-4
//           scroll-smooth
//           scrollbar-hide
//           snap-x snap-mandatory
//           justify-start
//         "
//       >
//         {products.map((product) => (
//           <ProductCard
//             key={product._id}
//             product={product}
//             showBuyNow={showBuyNow}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default ProductsRow;


import { useEffect, useRef, useState } from "react";
import ProductCard, {ProductCardSkeleton} from "../ProductCard";

export const ProductRowSkeleton = ({ count = 9 }) => {
  return (
    <section className="bg-white p-6 px-4 md:px-8">
      {/* TITLE */}
      <div className="h-6 w-40 bg-gray-300 rounded mx-auto mb-6 animate-pulse" />

      <div className="flex gap-6 overflow-hidden ">
        {Array.from({ length: count }).map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    </section>
  );
};


const ProductsRow = ({ title, products, showBuyNow }) => {
  const containerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkScroll = () => {
      setIsScrollable(el.scrollWidth > el.clientWidth);
    };

    checkScroll();
    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, [products]);

  if (!products?.length) return null;

  return (
    <section className=" px-4 md:px-8 bg-white">

      <h3 className="text-lg font-bold text-center mb-5 italic">
        {title}
      </h3>

      <div
        ref={containerRef}
        className={`
          flex gap-6
          pb-4
          scroll-smooth
          scrollbar-hide
          snap-x snap-mandatory
          overflow-x-auto
          ${isScrollable ? "justify-start" : "justify-center"}
        `}
      >
        {products.map((product) => (
          <ProductCard
            key={product._id}
            product={product}
            showBuyNow={showBuyNow}
          />
        ))}
      </div>
    </section>
  );
};

export default ProductsRow;
